function calendarDate(value) {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return {
      year: value.getFullYear(),
      month: value.getMonth() + 1,
      day: value.getDate(),
    };
  }

  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(year, month - 1, day);
  if (
    parsed.getFullYear() !== year
    || parsed.getMonth() + 1 !== month
    || parsed.getDate() !== day
  ) {
    return null;
  }
  return { year, month, day };
}

function pluralized(value, singular, plural = `${singular}s`) {
  return `${value} ${value === 1 ? singular : plural}`;
}

export function formatEmploymentLength(length, startDate, referenceDate = new Date()) {
  const enteredLength = String(length || '').trim();
  if (!enteredLength) return '';

  const isUnderOneYearChoice = /^(?:<\s*1\s*(?:yr|year)|less than 1 (?:yr|year))/i
    .test(enteredLength);
  if (!isUnderOneYearChoice) return enteredLength;

  const start = calendarDate(startDate);
  const end = calendarDate(referenceDate);
  if (!start || !end) return 'Less than 1 year';

  const startTimestamp = Date.UTC(start.year, start.month - 1, start.day);
  const endTimestamp = Date.UTC(end.year, end.month - 1, end.day);
  if (startTimestamp > endTimestamp) return 'Less than 1 year';

  let completeMonths = (end.year - start.year) * 12 + end.month - start.month;
  if (end.day < start.day) completeMonths -= 1;
  if (completeMonths >= 1) return pluralized(completeMonths, 'month');

  const elapsedDays = Math.floor((endTimestamp - startTimestamp) / 86400000);
  if (elapsedDays < 7) return 'Less than 1 week';
  return pluralized(Math.max(1, Math.round(elapsedDays / 7)), 'week');
}
